import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { I18N_NS_EXPENSE } from "../constants";
import { useNavigate } from "react-router-dom";
import { _str_capitalize } from "../../../utils/functions";
import moment from "moment";
import useMutationCreateExpense from "../api/mutations";
import useDialogCreateExpense from "./useDialogCreateExpense";
import useFormCreateExpense from "./useFormCreateExpense";

const useCreateExpense = () => {
    const { t } = useTranslation(I18N_NS_EXPENSE);
    const navigate = useNavigate();

    const [dialogShowToggle, setDialogShowToggle] = useState(false);
    const default_title_note = _str_capitalize(moment().format("MMMM YYYY"));

    const { is_loading_adding_note, mutate_add_note } =
        useMutationCreateExpense();

    const { methods, onSubmit } = useFormCreateExpense({
        default_title_note,
        mutate_add_note,
    });

    const { openDialog, hideDialog, onCancel, onConfirm } =
        useDialogCreateExpense({
            methods,
            onSubmit,
            setDialogShowToggle,
        });

    return {
        t,
        navigate,
        mutations: {
            create_note: {
                is_loading_adding_note,
                mutate_add_note,
            },
        },
        form: {
            methods,
            onSubmit,
        },
        dialog: {
            open: dialogShowToggle,
            openDialog,
            hideDialog,
            onCancel,
            onConfirm,
        },
    };
};

export default useCreateExpense;
